module.exports = __webpack_public_path__ + "static/media/login-image.5f820ea1.jpg";